import React from 'react'
import { Panel, Row, Col, Table, Message } from 'rsuite'

export default function CenterChangeFormInfo({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Panel>
        <Row>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>รหัสโครงการ : </b>
            {schema.projectInfo?.projectCode}
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <b>ชื่อโครงการ : </b>
            {schema.projectInfo?.projectName}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>ประเภทข้อเสนอโครงการ : </b>
            {schema.projectInfo?.projectType}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>ผู้รับทุน : </b>
            {schema.projectInfo?.grantee}
          </Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 10 }}>
            <b>ข้อมูลสัญญา </b>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <b>เลขที่ข้อตกลง : </b>
            {schema.contractChangeFormInfo?.contractNo}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>ประเภทสัญญา : </b>
            {schema.contractChangeFormInfo?.contractType}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>ประเภทการขอแก้ไขสัญญา : </b>
            {schema.contractChangeFormInfo?.contractChangeType}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>วันที่ขอแก้ไขสัญญา : </b>
            {schema.contractChangeFormInfo?.changeDate}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>วันที่อนุมัติแก้ไขสัญญา : </b>
            {schema.contractChangeFormInfo?.approvedDate}
          </Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <b>คำร้องขอของภาคี : </b>
            <div
              style={{ marginLeft: 30 }}
              dangerouslySetInnerHTML={{
                __html: schema.contractChangeFormInfo?.commentDescription || '- ไม่ระบุ -',
              }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Message
            type="info"
            style={{ marginBottom: 10 }}
            description={
              <>
                <b>ความเห็นนักวิชาการ : </b>
                {schema.contractChangeFormInfo?.summaryChanger || ''}
                <div
                  style={{ marginLeft: 30 }}
                  dangerouslySetInnerHTML={{
                    __html:
                      schema.contractChangeFormInfo?.changeSummaryDescription || '- ไม่ระบุ -',
                  }}
                />
              </>
            }
          />

          {schema.contractChangeComments?.map((e) => {
            return (
              <Message
                type="info"
                style={{ marginBottom: 10 }}
                description={
                  <>
                    <b>{e.roleName} : </b>
                    {e.name}
                    <div
                      style={{ marginLeft: 30 }}
                      dangerouslySetInnerHTML={{
                        __html: e.msg || '- ไม่ระบุ -',
                      }}
                    />
                  </>
                }
              />
            )
          })}
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <b>ข้อมูลผู้มีอำนาจลงนาม </b>
          </Col>
        </Row>
        <Table
          style={{ marginTop: 10 }}
          autoHeight
          //rowHeight={60}
          wordWrap
          data={schema.contractChangeSigners || []}
        >
          <Column width={100} align="center" fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column flexGrow={1} minWidth={200} width={200}>
            <HeaderCell>ชื่อ - นามสกุล</HeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column width={300}>
            <HeaderCell>ตำแหน่ง</HeaderCell>
            <Cell dataKey="position" />
          </Column>
        </Table>
        <Row style={{ marginTop: 20 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <b>สถานะเอกสาร{schema.header} : </b>
            {schema.contractChangeFormInfo?.status}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
